import { Button, Tooltip } from 'antd';
import { useCrudRecord } from '../../../containers/crud/recordContext';
import { secureApi } from '../../../hooks/api';
import { url } from '../../../constants/api';
import { RocketOutlined } from '@ant-design/icons';
import { useCrudData } from '../../../containers/crud/crudContext';

export const RedeployWebsite = () => {
  const { key, deploymentStatus } = useCrudRecord();
  const { refresh } = useCrudData();
  const redeploy = async () => {
    await secureApi(url(`websites/redeploy/${key}`));
    refresh();
  };
  return (
    <Tooltip title="Redeploy" placement="bottom">
      <Button className="btn blue-btn-text" onClick={redeploy}>
        <RocketOutlined />
      </Button>
    </Tooltip>
  );
};
